
import { Mail } from "lucide-react";
import { cn } from "@/lib/utils";

interface ContactButtonProps {
  email: string;
  className?: string;
}

export const ContactButton = ({ email, className }: ContactButtonProps) => {
  return (
    <a 
      href={`mailto:${email}`}
      className={cn(
        "inline-flex items-center px-8 py-4 bg-black text-white rounded-full text-[22px] font-medium hover:bg-gray-800 transition-colors",
        className
      )}
    >
      <Mail className="mr-2 h-6 w-6" />
      Contact Me
    </a>
  );
};
